// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LNRb","icon":"styles_icon__3bU0V"};